<script setup lang="ts">
import { CheckIcon } from "@kaleidoscope-solutions/ks-icons/vue/fill"
import {
  ExclamationMarkIcon,
  CheckRingIcon as GuessRoundIcon,
} from "@kaleidoscope-solutions/ks-icons/vue/light"

import { Decorator } from "@/types"

defineOptions({
  inheritAttrs: false,
})

defineProps<Props>()

interface Props {
  decorator: Decorator
  colourInvert?: boolean
}
</script>

<template>
  <CheckIcon
    v-if="decorator === Decorator.VALID"
    v-bind="$attrs"
    class="size-4 shrink-0"
    :class="{ 'text-green-400': !colourInvert }"
  />
  <div
    v-if="decorator === Decorator.VALID_GUESS"
    v-bind="$attrs"
    class="flex items-center gap-1"
  >
    <GuessRoundIcon
      v-tooltip="'Automated'"
      class="size-4 shrink-0"
      :class="{ 'text-green-400': !colourInvert }"
    />
    <slot name="guessText" />
  </div>
  <ExclamationMarkIcon
    v-if="decorator === Decorator.INVALID"
    v-tooltip="'Data missing'"
    v-bind="$attrs"
    class="size-4 shrink-0"
    :class="{ 'text-red-400': !colourInvert }"
  />
</template>
